import React, { useState, useEffect } from 'react';
import './CardDetailsForm.css'; // reuse same styles

interface PlanChangePopupProps {
  currentPlan: 'Lite' | 'Premium' | 'Plus';
  currentPeriod: 'monthly' | 'annually';
  onCancel: () => void;
  onSubmit: (plan: 'Lite' | 'Premium' | 'Plus', period: 'monthly' | 'annually') => void;
}

const PRICES: Record<'Lite' | 'Premium' | 'Plus', { monthly: string; annually: string }> = {
  Lite: { monthly: '$79.99 CAD/month', annually: '$799.90 CAD/year' },
  Premium: { monthly: '$149.99 CAD/month', annually: '$1,499.90 CAD/year' },
  Plus: { monthly: '$249.99 CAD/month', annually: '$2,499.90 CAD/year' },
};

export default function PlanChangePopup({
  currentPlan,
  currentPeriod,
  onCancel,
  onSubmit,
}: PlanChangePopupProps) {
  const [selectedPlan, setSelectedPlan] = useState<{ plan: typeof currentPlan; period: typeof currentPeriod }>({
    plan: currentPlan,
    period: currentPeriod,
  });

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const handleConfirm = () => {
    if (
      selectedPlan.plan === currentPlan &&
      selectedPlan.period === currentPeriod
    ) {
      onCancel(); // no change
      return;
    }
    onSubmit(selectedPlan.plan, selectedPlan.period);
  };

  return (
    <div className="cdp-overlay">
      <div className="cdp-container">
        <div className="cdp-header">Choose a Plan</div>
        <div className="cdp-body">
          <div className="plan-grid">
            {(['Lite', 'Premium', 'Plus'] as const).flatMap((plan) =>
              (['monthly', 'annually'] as const).map((period) => {
                const isCurrent = plan === currentPlan && period === currentPeriod;
                const isSelected = selectedPlan.plan === plan && selectedPlan.period === period;

                let boxClass = 'plan-box';
                if (isSelected) boxClass += ' plan-selected';
                else if (isCurrent) boxClass += ' plan-current';

                return (
                  <div
                    key={`${plan}-${period}`}
                    className={boxClass}
                    onClick={() => setSelectedPlan({ plan, period })}
                  >
                    <div className="plan-name">{plan}</div>
                    <div className="plan-price">{PRICES[plan][period]}</div>
                    <div className="plan-period">{period === 'monthly' ? 'Monthly' : 'Annually'}</div>
                  </div>
                );
              })
            )}
          </div>

          <div className="cdp-actions">
            <button className="cdp-btn cdp-cancel" onClick={onCancel}>Cancel</button>
            <button className="cdp-btn cdp-submit" onClick={handleConfirm}>Confirm</button>
          </div>
        </div>
      </div>
    </div>
  );
}
